<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
          <div v-if="trainee_first_followups.length > 0" class="mt-4">
            <h4>Beginning Training Followup </h4>
          </div>
          <div v-if="trainee_first_followups.length > 0" class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
              <tr>
                <th>SL</th>
                <th>FollowUp Form No.</th>
                <th>TNA Form No.</th>
                <th>Name</th>
                <th>Mouza</th>
                <th>Created Date</th>
                <th>Option</th>
              </tr>
              </thead>
              <tbody>
              <tr  v-for="(trainee_first_followup, index) in trainee_first_followups" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ trainee_first_followup.form_no }}</td>
                <td>{{ trainee_first_followup.trainee.form_no }}</td>
                <td>{{ trainee_first_followup.trainee.rep_name ?  trainee_first_followup.trainee.rep_name : trainee_first_followup.trainee.name }}</td>
                <td>{{ trainee_first_followup.trainee.mouza.desc }}</td>
                <td>{{ customDate(trainee_first_followup.created_at) }}</td>
                <td>
                  <router-link
                      :to="{name: 'traineeFollowupView',params: { followup_id: trainee_first_followup.id }}"
                      tag="a"
                      class="action-icon" target="_blank" title="Trainee Followup View">
                    <i class="mdi mdi-details editButton"></i>
                  </router-link>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <div v-if="trainee_followups.length > 0" class="mt-4">
            <h4>After Training Followup </h4>
          </div>
          <div v-if="trainee_followups.length > 0" class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
              <tr>
                <th>SL</th>
                <th>FollowUp Form No.</th>
                <th>TNA Form No.</th>
                <th>Name</th>
                <th>Mouza</th>
                <th>Created Date</th>
                <th>Option</th>
              </tr>
              </thead>
              <tbody>
              <tr  v-for="(trainee_followup, index) in trainee_followups" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ trainee_followup.form_no }}</td>
                <td>{{ trainee_followup.trainee.form_no }}</td>
                <td>{{ trainee_followup.trainee.rep_name ?  trainee_followup.trainee.rep_name : trainee_followup.trainee.name }}</td>
                <td>{{ trainee_followup.trainee.mouza.desc }}</td>
                <td>{{ customDate(trainee_followup.created_at) }}</td>
                <td>
                  <router-link
                      :to="{name: 'traineeFollowupView',params: { followup_id: trainee_followup.id }}"
                      tag="a"
                      class="action-icon" target="_blank" title="Trainee Followup View">
                    <i class="mdi mdi-details editButton"></i>
                  </router-link>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <div v-if="trainee_followup_docs.length > 0" class="mt-4">
            <h4>Training Followup Docs </h4>
          </div>
          <div v-if="trainee_followup_docs.length > 0" class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
              <tr>
                <th>SL</th>
                <th>Caption</th>
                <th>File</th>
                <th>Remarks</th>
              </tr>
              </thead>
              <tbody>
              <tr  v-for="(trainee_followup_doc, index) in trainee_followup_docs" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ trainee_followup_doc.caption }}</td>
                <td>
                  <a :href="trainee_followup_doc.name" target="_blank" download>
                    <img :src="trainee_followup_doc.name" alt="" class="rounded-circle" height="30px" width="30px"/>
                  </a>
                </td>
                <td>{{ trainee_followup_doc.remarks }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/profile-layout";
import PageHeader from "@components/page-header";
import http from "@state/http";
import moment from "moment";

export default {
  page: {
    title: "Trainee Followup List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout, PageHeader },
  data() {
    return {
      title: "Trainee Followup",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Trainee Followup",
          active: true
        }
      ],
      flag: false,
      trainee_id: '',
      trainee_followups: [],
      trainee_first_followups: [],
      trainee_followup_docs: [],
      form_no: '',
    };
  },


  mounted() {
    this.getFollowup();
  },
  methods: {
    customDate(date) {
      return moment.utc(date).local().format("L LT");
    },
    async getFollowup() {
       let trainee_id = this.$route.params.trainee_id;
      await http.get("api/trainee/profile/followup/list/" + trainee_id)
          .then(resource => {
            this.trainee_followups = resource.data.followups
            this.trainee_first_followups = resource.data.first_followups
            this.trainee_followup_docs = resource.data.trainee_followup_docs
          })
          .catch(error => {
            console.log(error)
          })
    },
  },
};
</script>
